<script>
    import { roundTheBoardPlayers } from "../store";
    import { createEventDispatcher, onMount } from "svelte";
    import { Round } from "../roundtheboard.model";

    const dispatch = createEventDispatcher();

    export let rounds = [];
    export let roundTheBoardQuickGame = false;
    export let roundTheBoardNrOfBulls = 0;

    let currentRoundIndex = 0;
    let activePlayerIndex = 0;
    let gameFinished = false;
    let nrOfDarts = 0;

    onMount(() => {
        highlightNextNumber();
    });

    function highlightNextNumber() {
        if (!rounds || rounds[currentRoundIndex] === undefined) return;
        let elementId = "number".concat(rounds[currentRoundIndex]);

        if (rounds[currentRoundIndex].includes("Bull")) {
            elementId = "single-bull";
        }

        let numberToHighlight = document.getElementById(elementId);
        if (numberToHighlight) {
            numberToHighlight.style.fill = "#F7931D";
        }
    }

    function resetHighlightNumber(roundIndex) {
        if (!rounds || rounds[roundIndex] === undefined) return;
        let elementId = "number".concat(rounds[roundIndex]);
        let color = "#FFFFFF";

        if (rounds[roundIndex].includes("Bull")) {
            elementId = "single-bull";
            color = "#00A000";
        }

        let numberToHighlight = document.getElementById(elementId);
        if (numberToHighlight) {
            numberToHighlight.style.fill = color;
        }
    }

    function handleScore(field) {
        if (nrOfDarts < 3 && !gameFinished) {
            nrOfDarts++;
            let previousRoundIndex = currentRoundIndex;

            if (field === "triple") {
                currentRoundIndex = currentRoundIndex + 3;
            }
            if (field === "double") {
                currentRoundIndex = currentRoundIndex + 2;
            }
            if (field === "single") {
                currentRoundIndex = currentRoundIndex + 1;
            }

            checkWinner();

            if (!gameFinished) {
                resetHighlightNumber(previousRoundIndex);
                highlightNextNumber();
            }
        }
    }

    function handleEndRound() {
        if (gameFinished) return;
        addScore();
        next();
    }

    function addScore() {
        const round = new Round(rounds[currentRoundIndex], 0, 0);

        roundTheBoardPlayers.update((players) => {
            players[activePlayerIndex].history = [
                ...players[activePlayerIndex].history,
                round,
            ];
            return [...players];
        });
    }

    function next() {
        nrOfDarts = 0;
        resetHighlightNumber(currentRoundIndex);

        if (activePlayerIndex === $roundTheBoardPlayers.length - 1) {
            activePlayerIndex = 0;
        } else {
            activePlayerIndex = activePlayerIndex + 1;
        }

        const historyLength = $roundTheBoardPlayers[activePlayerIndex].history.length;
        if (historyLength === 0) {
            currentRoundIndex = 0;
        } else {
            currentRoundIndex = rounds.indexOf(
                $roundTheBoardPlayers[activePlayerIndex].history[historyLength - 1].round
            );
        }

        highlightNextNumber();
    }

    function checkWinner() {
        if (rounds[currentRoundIndex] === undefined) {
            gameFinished = true;
        }
    }

    function getPlayerScore(player) {
        if (player.history.length > 0) {
            return player.history[player.history.length - 1].round;
        } else {
            return 20;
        }
    }

    function newGame() {
        dispatch("newGame");
    }

    function newRound() {
        let roundToResetHighlight = currentRoundIndex;
        if (rounds[currentRoundIndex] === undefined) {
            roundToResetHighlight = rounds.length - 1;
        }
        resetHighlightNumber(roundToResetHighlight);

        activePlayerIndex = 0;
        currentRoundIndex = 0;
        gameFinished = false;
        nrOfDarts = 0;
        highlightNextNumber();
        dispatch("reset", {
            roundTheBoardQuickGame: roundTheBoardQuickGame,
            roundTheBoardNrOfBulls: roundTheBoardNrOfBulls
        });
    }

    function previousPlayer() {
        if (activePlayerIndex === 0) {
            activePlayerIndex = $roundTheBoardPlayers.length - 1;
        } else {
            activePlayerIndex = activePlayerIndex - 1;
        }
    }

    function removeHistoryAndUpdateCurrentRoundIndex() {
        const newActivePlayer = $roundTheBoardPlayers[activePlayerIndex];
        roundTheBoardPlayers.update((players) => {
            newActivePlayer.history = newActivePlayer.history.slice(0, -1);
            return [...players];
        });
        const newActivePlayerHistoryLength = newActivePlayer.history.length;
        if (newActivePlayer.history.length === 0) {
            currentRoundIndex = 0;
        } else {
            currentRoundIndex = rounds.indexOf(
                newActivePlayer.history[newActivePlayerHistoryLength - 1].round
            );
        }
    }

    function undo() {
        if (gameFinished && rounds[currentRoundIndex] === undefined) {
            currentRoundIndex = rounds.length - 1;
            gameFinished = false;
        }

        let previousRoundIndex = currentRoundIndex;

        const activePlayer = $roundTheBoardPlayers[activePlayerIndex];
        const historyLength = activePlayer.history.length;
        if (
            (historyLength === 0 && currentRoundIndex === 0) ||
            (historyLength > 0 &&
                activePlayer.history[historyLength - 1].round ===
                    rounds[currentRoundIndex])
        ) {
            previousPlayer();
            removeHistoryAndUpdateCurrentRoundIndex();
        } else if (
            (historyLength === 0 && currentRoundIndex > 0) ||
            activePlayer.history[historyLength - 1].round !==
                rounds[currentRoundIndex]
        ) {
            if (historyLength === 0) {
                currentRoundIndex = 0;
            } else {
                currentRoundIndex = rounds.indexOf(
                    activePlayer.history[historyLength - 1].round
                );
            }
        }

        resetHighlightNumber(previousRoundIndex);
        highlightNextNumber();
        nrOfDarts = 0;
    }

    function handleKeyPress(event) {
        const pressedKey = event.key;
        switch (pressedKey) {
            case "t":
            case "3":
                if (!(currentRoundIndex >= rounds.length - roundTheBoardNrOfBulls - 2 || gameFinished || nrOfDarts === 3)) {
                    handleScore("triple");
                }
                break;
            case "d":
            case "2":
                if (!(currentRoundIndex === rounds.length - roundTheBoardNrOfBulls - 1 || gameFinished || nrOfDarts === 3)) {
                    handleScore("double");
                }
                break;
            case "s":
            case "1":
                if (!(gameFinished || nrOfDarts === 3)) {
                    handleScore("single");
                }
                break;
            case "Enter":
                event.preventDefault();
                handleEndRound();
                break;
            default:
                break;
        }
    }

    function isPlayerActive(player, finished = gameFinished, activeIdx = activePlayerIndex) {
        return !finished && $roundTheBoardPlayers[activeIdx]?.name === player?.name;
    }

    function isPlayerWinner(player, finished = gameFinished, activeIdx = activePlayerIndex) {
        return finished && $roundTheBoardPlayers[activeIdx]?.name === player?.name;
    }

    $: activePlayer = $roundTheBoardPlayers[activePlayerIndex];
    $: canUndo = $roundTheBoardPlayers.some(p => p.history.length > 0) || currentRoundIndex > 0 || nrOfDarts > 0 || activePlayerIndex > 0;
    $: isTripleDisabled = (currentRoundIndex >= rounds.length - roundTheBoardNrOfBulls - 2) || gameFinished || nrOfDarts === 3;
    $: isDoubleDisabled = (currentRoundIndex === rounds.length - roundTheBoardNrOfBulls - 1) || gameFinished || nrOfDarts === 3;
    $: isSingleDisabled = gameFinished || nrOfDarts === 3;
</script>

<svelte:window on:keypress={handleKeyPress} />

<div class="roundtheboard-screen w-full h-screen min-h-screen text-slate-900 font-sans antialiased flex flex-col p-3 sm:p-4 md:p-5 lg:p-6 box-border" style="background-color: #f0ece9;">
    <!-- BEGIN: TopControlsBar -->
    <header class="w-full max-w-[1600px] mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-sm px-4 sm:px-6 py-3 mb-3 sm:mb-4 border border-black/5 flex flex-wrap items-center justify-between gap-4 shrink-0">
        <!-- Brand Group -->
        <div class="flex items-center gap-4 sm:gap-6 min-w-[200px]">
            <button class="inline-flex items-center transition-opacity hover:opacity-85 focus:outline-none" on:click={newGame} title="Yuma Home">
                <img alt="Yuma Logo" class="h-8 sm:h-9 w-auto object-contain" src="images/yuma.png" />
            </button>
            <div class="h-8 w-px bg-slate-200"></div>
            <div class="flex items-center gap-2">
                <span class="font-bold text-slate-800 text-sm sm:text-base font-headline">Round the board</span>
                {#if roundTheBoardQuickGame}
                    <span class="text-[11px] font-bold uppercase tracking-wider bg-purple-100 text-[#6434da] px-2 py-0.5 rounded-md">Quick</span>
                {/if}
            </div>
        </div>

        <!-- Center Score Actions Console -->
        <div class="flex items-center justify-center flex-1 max-w-2xl mx-auto order-last md:order-none w-full md:w-auto">
            <div class="flex items-center gap-2 bg-stone-100/80 p-1.5 rounded-2xl border border-slate-200 shadow-inner justify-center flex-wrap sm:flex-nowrap">
                <!-- Triple button -->
                <button
                    class="h-11 inline-flex items-center justify-center gap-1.5 bg-[#005d46] hover:bg-[#004a37] active:scale-[0.98] text-white font-bold px-3.5 sm:px-4 rounded-xl transition-all shadow-sm cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed text-sm sm:text-base flex-1 sm:flex-initial"
                    type="button"
                    on:click={() => handleScore("triple")}
                    disabled={isTripleDisabled}
                    title="Triple (Press 3 or T)"
                >
                    <span>Triple</span>
                    <span class="text-[10px] bg-white/20 text-white px-1.5 py-0.5 rounded font-mono font-normal">3</span>
                </button>

                <!-- Double button -->
                <button
                    class="h-11 inline-flex items-center justify-center gap-1.5 bg-[#007054] hover:bg-[#005d46] active:scale-[0.98] text-white font-bold px-3.5 sm:px-4 rounded-xl transition-all shadow-sm cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed text-sm sm:text-base flex-1 sm:flex-initial"
                    type="button"
                    on:click={() => handleScore("double")}
                    disabled={isDoubleDisabled}
                    title="Double (Press 2 or D)"
                >
                    <span>Double</span>
                    <span class="text-[10px] bg-white/20 text-white px-1.5 py-0.5 rounded font-mono font-normal">2</span>
                </button>

                <!-- Single button -->
                <button
                    class="h-11 inline-flex items-center justify-center gap-1.5 bg-[#007054] hover:bg-[#005d46] active:scale-[0.98] text-white font-bold px-3.5 sm:px-4 rounded-xl transition-all shadow-sm cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed text-sm sm:text-base flex-1 sm:flex-initial"
                    type="button"
                    on:click={() => handleScore("single")}
                    disabled={isSingleDisabled}
                    title="Single (Press 1 or S)"
                >
                    <span>Single</span>
                    <span class="text-[10px] bg-white/20 text-white px-1.5 py-0.5 rounded font-mono font-normal">1</span>
                </button>

                <!-- Next Player button -->
                <button
                    class="h-11 inline-flex items-center justify-center gap-2 bg-[#eba9ff] hover:bg-[#e493fc] active:scale-[0.98] text-[#005d46] font-bold px-4 sm:px-5 rounded-xl transition-all shadow-sm border border-purple-300/40 whitespace-nowrap cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed flex-1 sm:flex-initial"
                    type="button"
                    on:click={handleEndRound}
                    disabled={gameFinished}
                    title="Next player (Press Enter)"
                >
                    <span>Next player</span>
                    <span class="material-symbols-outlined text-[18px]">arrow_forward</span>
                </button>
            </div>
        </div>

        <!-- Right Quick Actions (Undo, Reset Round, Home) -->
        <div class="flex items-center justify-end gap-2.5 min-w-[200px] sm:min-w-[240px]">
            <!-- Undo Button -->
            <button
                class="h-11 w-11 inline-flex items-center justify-center rounded-xl bg-pink-50 hover:bg-pink-100 text-rose-600 transition-colors border border-rose-200/50 cursor-pointer active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
                title="Undo last score"
                type="button"
                on:click={undo}
                disabled={!canUndo}
            >
                <span class="material-symbols-outlined text-[20px]">undo</span>
            </button>
            <!-- New Round Button -->
            <button
                class="h-11 inline-flex items-center gap-2 bg-[#6434da] hover:bg-[#5229b5] text-white text-sm font-semibold px-4 rounded-xl transition-colors shadow-sm cursor-pointer active:scale-95"
                type="button"
                on:click={newRound}
            >
                <span class="material-symbols-outlined text-[18px]">restart_alt</span>
                <span class="hidden sm:inline">New round</span>
            </button>
            <!-- Exit to Setup / Lobby -->
            <button
                class="h-11 w-11 inline-flex items-center justify-center rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 transition-colors border border-slate-200 cursor-pointer active:scale-95"
                title="Exit to Setup"
                type="button"
                on:click={newGame}
            >
                <span class="material-symbols-outlined text-[20px]">home</span>
            </button>
        </div>
    </header>
    <!-- END: TopControlsBar -->

    <!-- BEGIN: Main Game Container -->
    <main class="w-full max-w-[1600px] mx-auto flex-1 flex flex-col lg:flex-row gap-4 sm:gap-6 min-h-0 items-stretch">
        <!-- Dartboard Card -->
        <div class="bg-white rounded-2xl sm:rounded-3xl shadow-md border border-black/5 p-4 sm:p-6 flex flex-col items-center justify-center flex-1 w-full lg:w-auto h-full min-h-0">
            <!-- Active Target Sub-Header on Dartboard -->
            <div class="w-full flex items-center justify-between mb-3 px-2 shrink-0">
                <div class="flex items-center gap-3">
                    <span class="text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-wider font-headline">Target</span>
                    <span class="text-xl sm:text-2xl font-black text-[#005d46] font-headline">
                        {gameFinished ? "Finished!" : (rounds[currentRoundIndex] || "-")}
                    </span>
                </div>
                <!-- Darts thrown indicator -->
                <div class="flex items-center gap-1.5 bg-stone-100 px-3 py-1.5 rounded-full border border-slate-200">
                    <span class="text-xs font-bold text-slate-500 uppercase mr-1">Darts:</span>
                    {#each [1, 2, 3] as dartNum}
                        <div
                            class="w-3 h-3 rounded-full transition-colors {
                                nrOfDarts >= dartNum
                                    ? 'bg-[#005d46] shadow-sm ring-2 ring-[#005d46]/30'
                                    : 'bg-slate-200'
                            }"
                        ></div>
                    {/each}
                </div>
            </div>

            <!-- Dartboard SVG -->
            <div class="w-full flex items-center justify-center flex-1 min-h-0 p-2">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    id="body_1"
                    viewBox="0 0 710 710"
                    class="w-full h-full max-h-[580px] xl:max-h-[660px] 2xl:max-h-[720px] aspect-square select-none cursor-pointer drop-shadow-xl"
                >
                    <g transform="matrix(1.500785 0 0 1.501057 0 0)">
                        <g transform="matrix(1 0 0 1 236.5 236.5)" />
                        <path
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            d="M226.5 0C 226.5 80.92066 183.3293 155.6944 113.25 196.1548C 43.17064 236.6151 -43.17068 236.6151 -113.25 196.1548C -183.3294 155.6944 -226.5 80.92066 -226.5 2.773733E-14C -226.5 -80.92066 -183.3293 -155.6944 -113.25 -196.1548C -43.17064 -236.6151 43.17068 -236.6151 113.25 -196.1548C 183.3294 -155.6944 226.5 -80.92066 226.5 -5.547467E-14L226.5 -5.547467E-14L226.5 0z"
                            stroke="none"
                            fill="#000000"
                            fill-rule="nonzero"
                        />
                        <g transform="matrix(1 0 0 1 236.5 236.5)" />
                        <!-- Doubles red -->
                        <g on:click={() => handleScore("double")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(1 0 0 1 236.5 236.5)"
                                d="M170.55 0C 170.55 60.93165 138.0434 117.2348 85.27499 147.7006C 32.50663 178.1665 -32.50666 178.1665 -85.27502 147.7006C -138.0434 117.2348 -170.55 60.93165 -170.55 2.088566E-14C -170.55 -60.93165 -138.0434 -117.2348 -85.27499 -147.7006C -32.50663 -178.1665 32.50666 -178.1665 85.27502 -147.7006C 138.0434 -117.2348 170.55 -60.93165 170.55 -4.177132E-14L170.55 -4.177132E-14L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#FF0000"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(1 0 0 1 236.5 236.5)" />
                        <!-- Singles black outer circle -->
                        <g on:click={() => handleScore("single")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(1 0 0 1 236.5 236.5)"
                                d="M161.45 0C 161.45 57.68053 130.6778 110.9795 80.72499 139.8198C 30.77218 168.6601 -30.77221 168.6601 -80.72502 139.8198C -130.6778 110.9795 -161.45 57.68053 -161.45 1.977127E-14C -161.45 -57.68053 -130.6778 -110.9795 -80.72499 -139.8198C -30.77218 -168.6601 30.77221 -168.6601 80.72502 -139.8198C 130.6778 -110.9795 161.45 -57.68053 161.45 -3.954254E-14L161.45 -3.954254E-14L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#000000"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(1 0 0 1 236.5 236.5)" />
                        <!-- Trebles red -->
                        <g on:click={() => handleScore("triple")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(1 0 0 1 236.5 236.5)"
                                d="M107.55 0C 107.55 38.42392 87.05109 73.92908 53.775 93.14104C 20.49891 112.353 -20.49893 112.353 -53.77501 93.14103C -87.0511 73.92907 -107.55 38.42392 -107.55 1.317064E-14C -107.55 -38.42392 -87.05109 -73.92908 -53.775 -93.14104C -20.49891 -112.353 20.49893 -112.353 53.77501 -93.14103C 87.0511 -73.92907 107.55 -38.42392 107.55 -2.634128E-14L107.55 -2.634128E-14L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#FF0000"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(1 0 0 1 236.5 236.5)" />
                        <!-- Singles black inner circle -->
                        <g on:click={() => handleScore("single")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(1 0 0 1 236.5 236.5)"
                                d="M98.45 0C 98.45 35.1728 79.68553 67.67381 49.22499 85.2602C 18.76446 102.8466 -18.76447 102.8466 -49.22501 85.2602C -79.68555 67.67379 -98.45 35.1728 -98.45 1.205625E-14C -98.45 -35.1728 -79.68553 -67.67381 -49.22499 -85.2602C -18.76446 -102.8466 18.76447 -102.8466 49.22501 -85.2602C 79.68555 -67.67379 98.45 -35.1728 98.45 -2.41125E-14L98.45 -2.41125E-14L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#000000"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)" />
                        <!-- Doubles green -->
                        <g on:click={() => handleScore("double")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)" />
                            <path
                                transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)"
                                d="M170.55 0C 170.55 17.89682 167.7331 35.68197 162.2027 52.70285L162.2027 52.70285L0 0L170.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)" />
                        <!-- Singles green outer circle -->
                        <g on:click={() => handleScore("single")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)" />
                            <path
                                transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)"
                                d="M161.45 0C 161.45 16.9419 158.7834 33.77809 153.5481 49.89079L153.5481 49.89079L0 0L161.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)" />

                        <!-- Trebles green -->
                        <g on:click={() => handleScore("triple")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)" />
                            <path
                                transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)"
                                d="M107.55 0C 107.55 11.28585 105.7736 22.50129 102.2861 33.23478L102.2861 33.23478L0 0L107.55 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)" />
                        <!-- Singles white inner circle -->
                        <g on:click={() => handleScore("single")} class="hover:opacity-90 transition-opacity">
                            <path
                                transform="matrix(-0.45399 -0.891007 0.891007 -0.45399 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(-0.891006 -0.453991 0.453991 -0.891006 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(-0.987688 0.156434 -0.156434 -0.987688 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(-0.707107 0.707106 -0.707106 -0.707107 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(-0.156435 0.987688 -0.987688 -0.156435 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)" />
                            <path
                                transform="matrix(0.45399 0.891007 -0.891007 0.45399 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)" />
                            <path
                                transform="matrix(0.891006 0.453991 -0.453991 0.891006 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)" />
                            <path
                                transform="matrix(0.987688 -0.156434 0.156434 0.987688 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)" />
                            <path
                                transform="matrix(0.707107 -0.707106 0.707106 0.707107 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                            <g transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)" />
                            <path
                                transform="matrix(0.156435 -0.987688 0.987688 0.156435 236.5 236.5)"
                                d="M98.45 0C 98.45 10.33094 96.82395 20.59742 93.63151 30.42272L93.63151 30.42272L0 0L98.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#E7E4C7"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(1 0 0 1 236.5 236.5)" />
                        <!-- Single bull -->
                        <g on:click={() => handleScore("single")} class="hover:opacity-90 transition-opacity">
                            <path
                                id="single-bull"
                                transform="matrix(1 0 0 1 236.5 236.5)"
                                d="M16.45 0C 16.45 5.87702 13.31465 11.30761 8.224999 14.24612C 3.135351 17.18463 -3.135354 17.18463 -8.225002 14.24612C -13.31465 11.30761 -16.45 5.87702 -16.45 2.014477E-15C -16.45 -5.87702 -13.31465 -11.30761 -8.224999 -14.24612C -3.135351 -17.18463 3.135354 -17.18463 8.225002 -14.24612C 13.31465 -11.30761 16.45 -5.87702 16.45 -4.028955E-15L16.45 -4.028955E-15L16.45 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#00A000"
                                fill-rule="nonzero"
                            />
                        </g>
                        <g transform="matrix(1 0 0 1 236.5 236.5)" />
                        <!-- Double bull -->
                        <g on:click={() => handleScore("double")} class="hover:opacity-90 transition-opacity">
                            <path
                                id="double-bull"
                                transform="matrix(1 0 0 1 236.5 236.5)"
                                d="M6.9 0C 6.9 2.465133 5.584867 4.74301 3.45 5.975575C 1.315132 7.208142 -1.315133 7.208142 -3.450001 5.975575C -5.584868 4.743009 -6.9 2.465133 -6.9 8.449784E-16C -6.9 -2.465133 -5.584867 -4.74301 -3.45 -5.975575C -1.315132 -7.208142 1.315133 -7.208142 3.450001 -5.975575C 5.584868 -4.743009 6.9 -2.465133 6.9 -1.689957E-15L6.9 -1.689957E-15L6.9 0z"
                                stroke="#D0EDFD"
                                stroke-width="1.1"
                                fill="#FF0000"
                                fill-rule="nonzero"
                            />
                        </g>

                        <!-- Dartboard Numbers -->
                        <text
                            id="number20"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-16.95171"
                            y="-187.825"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            20
                        </text>
                        <text
                            id="number1"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="51.87223"
                            y="-180.3662"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            1
                        </text>
                        <text
                            id="number18"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="100.0151"
                            y="-150.5312"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            18
                        </text>
                        <text
                            id="number4"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="153.2435"
                            y="-103.7445"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            4
                        </text>
                        <text
                            id="number13"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="173.9245"
                            y="-45.76964"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            13
                        </text>
                        <text
                            id="number6"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="187.1469"
                            y="9.153896"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            6
                        </text>
                        <text
                            id="number10"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="171.5513"
                            y="67.46778"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            10
                        </text>
                        <text
                            id="number15"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="142.7334"
                            y="127.1378"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            15
                        </text>
                        <text
                            id="number2"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="106.1177"
                            y="169.8561"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            2
                        </text>
                        <text
                            id="number17"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="42.71831"
                            y="196.6398"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            17
                        </text>
                        <text
                            id="number3"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-6.102616"
                            y="208.167"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            3
                        </text>
                        <text
                            id="number19"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-74.2485"
                            y="199.0131"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            19
                        </text>
                        <text
                            id="number7"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-123.7475"
                            y="173.2464"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            7
                        </text>
                        <text
                            id="number16"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-174.9417"
                            y="127.1378"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            16
                        </text>
                        <text
                            id="number8"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-193.5885"
                            y="72.89233"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            8
                        </text>
                        <text
                            id="number11"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-214.6087"
                            y="8.814864"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            11
                        </text>
                        <text
                            id="number14"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-208.5061"
                            y="-48.82095"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            14
                        </text>
                        <text
                            id="number9"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-165.1096"
                            y="-109.5081"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            9
                        </text>
                        <text
                            id="number12"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-134.2576"
                            y="-152.2264"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            12
                        </text>
                        <text
                            id="number5"
                            transform="matrix(1 0 0 1 236.5 236.5)"
                            x="-67.46781"
                            y="-178.6711"
                            style="fill:#FFFFFF; font-family: 'Space Grotesk', system-ui, sans-serif; font-weight: 800;"
                            font-size="28"
                        >
                            5
                        </text>
                    </g>
                </svg>
            </div>
        </div>

        <!-- Players Scoreboard Card -->
        <div class="bg-white rounded-2xl sm:rounded-3xl shadow-md border border-black/5 p-4 sm:p-6 w-full lg:w-[420px] xl:w-[460px] 2xl:w-[500px] shrink-0 h-full flex flex-col min-h-0">
            <div class="flex items-center justify-between pb-3 mb-3 border-b border-slate-100 shrink-0">
                <div class="flex items-center gap-2">
                    <span class="material-symbols-outlined text-[#005d46] text-[22px]">groups</span>
                    <h2 class="font-bold text-slate-800 text-base sm:text-lg font-headline">Players</h2>
                </div>
                <span class="text-xs font-bold text-slate-400 uppercase tracking-wider">
                    {$roundTheBoardPlayers.length} {$roundTheBoardPlayers.length === 1 ? 'player' : 'players'}
                </span>
            </div>

            <!-- Scrollable Player Cards List -->
            <div class="flex flex-col gap-3 overflow-y-auto flex-1 pr-1">
                {#each $roundTheBoardPlayers as player, idx}
                    <div
                        class="rounded-2xl p-4 sm:p-5 transition-all flex items-center justify-between gap-4 border {
                            isPlayerWinner(player, gameFinished, activePlayerIndex)
                                ? 'bg-[#21e467] border-emerald-500 shadow-md text-[#005d46]'
                                : isPlayerActive(player, gameFinished, activePlayerIndex)
                                    ? 'bg-[#fff8e7] border-amber-300 ring-2 ring-amber-300/40 shadow-sm'
                                    : 'bg-stone-50/80 border-slate-200/80 hover:bg-stone-100/80'
                        }"
                    >
                        <!-- Left: Player Info -->
                        <div class="flex items-center gap-3.5 min-w-0">
                            <!-- Avatar / Position Dot -->
                            <div
                                class="w-10 h-10 rounded-xl flex items-center justify-center font-bold font-headline text-base shrink-0 {
                                    isPlayerWinner(player, gameFinished, activePlayerIndex)
                                        ? 'bg-[#005d46] text-white shadow'
                                        : isPlayerActive(player, gameFinished, activePlayerIndex)
                                            ? 'bg-amber-400 text-amber-950 shadow-sm'
                                            : 'bg-slate-200 text-slate-700'
                                }"
                            >
                                {#if isPlayerWinner(player, gameFinished, activePlayerIndex)}
                                    <span class="text-xl">🏆</span>
                                {:else}
                                    {idx + 1}
                                {/if}
                            </div>

                            <div class="flex flex-col min-w-0">
                                <div class="flex items-center gap-2">
                                    <span class="font-bold text-base sm:text-lg truncate font-headline {isPlayerWinner(player, gameFinished, activePlayerIndex) ? 'text-[#005d46]' : 'text-slate-900'}">
                                        {player.name}
                                    </span>
                                </div>
                                <div class="flex items-center gap-2 text-xs">
                                    {#if isPlayerActive(player, gameFinished, activePlayerIndex)}
                                        <span class="inline-flex items-center gap-1 font-bold text-amber-800 bg-amber-100/80 px-2 py-0.5 rounded-md">
                                            <span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span>
                                            At Oche
                                        </span>
                                    {:else}
                                        <span class="text-slate-500 font-medium">
                                            {player.history.length} {player.history.length === 1 ? 'round' : 'rounds'} played
                                        </span>
                                    {/if}
                                </div>
                            </div>
                        </div>

                        <!-- Right: Target / Score Badge -->
                        <div class="flex flex-col items-end shrink-0">
                            <span class="text-[11px] uppercase tracking-wider font-bold {isPlayerWinner(player, gameFinished, activePlayerIndex) ? 'text-[#005d46]/80' : 'text-slate-400'} font-headline">
                                {isPlayerWinner(player, gameFinished, activePlayerIndex) ? 'Winner' : isPlayerActive(player, gameFinished, activePlayerIndex) ? 'Current Target' : 'Last Reached'}
                            </span>
                            <span
                                class="text-2xl sm:text-3xl font-black font-headline tracking-tight {
                                    isPlayerWinner(player, gameFinished, activePlayerIndex)
                                        ? 'text-[#005d46]'
                                        : isPlayerActive(player, gameFinished, activePlayerIndex)
                                            ? 'text-[#005d46]'
                                            : 'text-slate-700'
                                }"
                            >
                                {#if isPlayerWinner(player, gameFinished, activePlayerIndex)}
                                    Done!
                                {:else if isPlayerActive(player, gameFinished, activePlayerIndex)}
                                    {rounds[currentRoundIndex] || "-"}
                                {:else}
                                    {getPlayerScore(player)}
                                {/if}
                            </span>
                        </div>
                    </div>
                {/each}
            </div>

            <!-- Footer Info Hint -->
            <div class="mt-3 pt-3 border-t border-slate-100 text-xs text-slate-400 flex items-center justify-between shrink-0 font-medium">
                <span>Shortcuts: <strong>1/S</strong> Single, <strong>2/D</strong> Double, <strong>3/T</strong> Triple, <strong>Enter</strong> Next</span>
            </div>
        </div>
    </main>
    <!-- END: Main Game Container -->
</div>
